import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import Vue from 'vue'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  const loggedIn = store.getters['auth/token']
  const { roles } = to.meta
  const currentUser = store.getters['auth/profile']
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (loggedIn === '') {
      next({
        name: 'login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      if (roles === undefined || (roles.length && !roles.includes(currentUser.role))) {
        // role not authorised so redirect to home page
        next({ name: 'home' })
      }
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (loggedIn === '') {
      next()
    } else {
      next({ name: 'home' })
      NProgress.done()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || 'Portal Admin'
  })
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permissions.js